/* Vintage Optics series page: city tabs, "In Mark's Work" slideshows, and the
   Ask Us a Question modal (posts to Formspree). Markup: sections/vintage-optics.liquid. */
(function () {
  var tabs = document.querySelectorAll('.vo-tab');
  var panels = document.querySelectorAll('.vo-panel');

  function activate(city) {
    tabs.forEach(function (t) {
      var on = t.getAttribute('data-city') === city;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    panels.forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-city') === city);
    });
  }
  tabs.forEach(function (t) {
    t.addEventListener('click', function () { activate(t.getAttribute('data-city')); });
  });

  document.querySelectorAll('.vo-slideshow').forEach(function (ss) {
    var slides = ss.querySelectorAll('.vo-slideshow__slide');
    if (!slides.length) return;
    var counter = ss.querySelector('.vo-slideshow__counter');
    var n = slides.length, i = 0, timer = null;
    function show(k) {
      i = (k + n) % n;
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
      if (counter) counter.textContent = (i + 1) + ' / ' + n;
    }
    function play() { stop(); timer = setInterval(function () { show(i + 1); }, 5000); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    var prev = ss.querySelector('.vo-slideshow__prev');
    var next = ss.querySelector('.vo-slideshow__next');
    if (prev) prev.addEventListener('click', function () { show(i - 1); play(); });
    if (next) next.addEventListener('click', function () { show(i + 1); play(); });
    ss.addEventListener('mouseenter', stop);
    ss.addEventListener('mouseleave', play);
    show(0);
    play();
  });

  var modal = document.getElementById('vo-modal');
  if (!modal) return;
  function openModal() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  var pu = modal.querySelector('input[name="page_url"]');
  if (pu) pu.value = location.href;
  document.querySelectorAll('[data-vo-open-modal]').forEach(function (b) { b.addEventListener('click', openModal); });
  modal.querySelectorAll('[data-vo-close-modal]').forEach(function (b) { b.addEventListener('click', closeModal); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

  var form = modal.querySelector('.vo-form');
  var status = modal.querySelector('[data-vo-status]');
  var submit = modal.querySelector('button[type="submit"]');
  var fail = 'Something went wrong. Please email us at info@camerawest.com.';
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    status.textContent = 'Sending…';
    submit.disabled = true;
    fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (r.ok) {
          form.reset();
          status.textContent = 'Thank you — your question has been sent. A member of our team will be in touch shortly.';
        } else {
          status.textContent = fail;
        }
        submit.disabled = false;
      })
      .catch(function () { status.textContent = fail; submit.disabled = false; });
  });
})();
